// Common API's
const GetWorkOrderTypesAndCategories = 'Common/GetWorkOrderTypesAndCategories'
const GetWorkorderStages = 'Common/GetWorkorderStages'
const GetCountryStates = 'Common/GetCountryStates'
const GetDocumentTemplateData = 'Common/GetDocumentTemplateData'
const GetUserCompanies = 'Company/GetUserCompanies'
const GetInActiveInvoiceById = 'Common/GetInActiveInvoiceById'
const SyncForWaypoint = "SyncForWaypoint"
// Dashboard API's
const GetCustomerWorkorders = 'Dashboard/GetCustomerWorkorders'
const FilterWorkorders = 'Dashboard/FilterWorkorders'
const GetVesselDashboard = 'getVesselDashboard'
const UpdateSubscription = 'UpdateSubscription'
const GetUsers = 'UserManagement/GetUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveUserRoles'
// QB Dashboard API's
const QBFilterWorkorders = 'Dashboard/QBFilterWorkorders'

// Company API's
const GetSFCompaniesByName = 'Company/GetSFCompaniesByName'
const CreateCompany = 'Company/CreateCompany'
const GetCompanyDetails = 'Company/GetSSCompanyList'
const GetParentCompany = 'GetParentCompany'
const ValidateClient = 'ValidateClient'
const ValidateWorkorderCreation = 'ValidateWorkorderCreation'

// Workorders API's
const GetBaseWorkOrderData = 'GetBaseWorkOrderData'
const CreateWorkorder = 'CreateWorkorder'
const UpdateWorkorderData = 'UpdateWorkorderData'
const UpdateExpenses = 'UpdateExpenses'
const GetWorkorderById = 'GetWorkorderById'
const UpdateWorkorder = 'UpdateWorkorder'
const RemoveWorkorderDocument = 'FileUpload/RemoveWorkorderDocument'
const RequestMoreInfo = 'RequestMoreInfo'
const GetInvoiceDocument = 'GetInvoiceDocument'
const GetPreviewDocument = 'PreviewAuthorizationDocument'
const PreviewLLABDocument = 'PreviewLLABDocument'
const UpdateNeedMoreInfoStatus = 'UpdateNeedMoreInfoStatus'
const CancelWorkorder = 'CancelWorkorder'
const SuspendWorkorder = 'SuspendWorkorder'
const ReactivateWorkorder = 'ReactivateWorkorder'
const ArchivedWorkorder = 'ArchivedWorkorder'
const ResendDocusignEmail = 'ResendDocusignEmail'
const SendAcknowledgementMail = 'SendAcknowledgementMail'
const GetAuthorizationDocument = 'GetAuthorizationDocument'
const ValidateVesselDetails = 'ValidateVesselDetails'
const GetWorkOrderFilesByFileId = 'FileUpload/GetWorkOrderFilesByFileId'
const GetVesselOwnersData = 'GetVesselOwnersData'
const GetVendorsData = 'GetVendorsData'
const GetAllVendorsData = 'GetAllVendorsData'
const GetBillableVoyAges = 'GetBillableVoyAges'
const GetUpdatedBillableVoyages = 'GetUpdatedBillableVoyages'
const GetCompanyAddressdetails = 'Company/GetCompanyAddressdetails'
const GetAllProducts = 'GetAllProducts'
const GetCurrentQBbyCompany = 'GetCurrentQBbyCompany'
const GetERBPCListByIMONumber = 'GetERBPCListByIMONumber'
const GetProductsDataByIMONumber = 'GetProductsDataByIMONumber'
const GetVesselDetailsByIMONumber = 'GetVesselDetailsByIMONumber'
const GetClassesList = 'GetClassesList'
// Workorder Comments Api's
const GetWorkorderComments = 'WorkorderComment/GetWorkorderComments'
const CreateComment = 'WorkorderComment/CreateComment'

// IHM SOC API's
const GetAllVesselsByAccountId = 'GetAllVesselsByAccountId'
const GetVesselByofficialnumber = 'GetVesselByOfficialNumber'
const GetVesselByIMONumber = 'GetVesselByIMONumber'
const GetSoftwareVersionPClist = 'GetSoftwareVersionPClist'
const ResendEmails = 'ResendEmails'
const UpdateBillingPrefix = 'UpdateBillingPrefix'
const CancelWorkorderInvoice = "CancelWorkorderInvoice"
const UpdateResendEmail = 'ResendEmail'
const RegenerateAuthorizationLetter = 'RegenerateAuthorizationLetter'
const RegenerateLLABDocument = 'RegenerateLLABDocument'
const UpdateNdaDocument = 'UpdateNdaDocument'
const GetVesselSyncData = 'GetVesselSyncData'
//RLM
const GetListFiles = "GetOnlineLibraryFiles"
const GetImoListFiles = "GetNaviregoFilesList"
const GetFileUrl = "GetFileUrl"
const GetAllActiveVaultsForUser = "GetActiveVaultsForUser"
const UpdateCustomerVault = "UpdateCustomerVault"
const DownloadFile = "DownloadFile"
const GetCompanyAddress = "Company/GetCompanyAddressdetails"
const GetLastModifiedFiles = "GetLastModifiedFiles"
const GetSearchLibrary = "SearchLibrary"
const GetAllVesselsByAgent = "GetAllVesselsByAgent"
const SendFeedBackEmail = 'Dashboard/SendFeedBackEmail'

// Investigation
const GetPortCities = 'GetPortCities'
const GetPortByName = "GetPortByName"
const GetInspectorByName = 'GetInspectorByName'
const GetInvestigatorByCityId = 'GetInvestigatorByCityId'
const GetAllInvestigators = 'GetAllInvestigators'
const GetExpenseProducts = 'GetExpenseProducts'
const GetVesselByIMO = 'GetVesselByIMO'
const GetInspectorDetailsByPortId = "GetInspectorDetailsByPortId"
const GetAccountByAgentId = "Common/GetAccountByAgentId"
const GetWorkorderProducts = "GetWorkorderProducts"
const GetDiscountProductCodeAmount = "Common/GetDiscountProductCodeAmount"
const CancelAndReplaceWorkorderInvoice = "CancelAndReplaceWorkorderInvoice"

// LLABA
const LLABParentWorkOrders = "LLABParentWorkOrders"
const LLABAmendmentWorkOrderData = "LLABAmendmentWorkOrderData"
const RegenerateLLABADocument = "RegenerateLLABADocument"
const PreviewLLABADocument = "PreviewLLABADocument"

export const ApiUrls = {
  GetWorkOrderTypesAndCategories,
  GetWorkorderStages,
  GetCountryStates,
  GetDocumentTemplateData,
  GetUserCompanies,
  GetInActiveInvoiceById,
  SyncForWaypoint,

  GetCustomerWorkorders,
  FilterWorkorders,
  GetVesselDashboard,
  UpdateSubscription,
  GetUsers,
  GetUserRoles,
  SaveUserRoles,
  QBFilterWorkorders,
  GetCompanyDetails,
  GetParentCompany,
  ValidateClient,

  GetSFCompaniesByName,
  CreateCompany,
  ValidateWorkorderCreation,

  GetBaseWorkOrderData,
  CreateWorkorder,
  UpdateWorkorderData,
  UpdateExpenses,
  GetWorkorderById,
  UpdateWorkorder,
  RemoveWorkorderDocument,
  RequestMoreInfo,
  GetInvoiceDocument,
  GetPreviewDocument,
  PreviewLLABDocument,
  UpdateNeedMoreInfoStatus,
  CancelWorkorder,
  ArchivedWorkorder,
  SuspendWorkorder,
  ReactivateWorkorder,
  ResendDocusignEmail,
  SendAcknowledgementMail,
  ValidateVesselDetails,
  GetWorkOrderFilesByFileId,
  GetVesselOwnersData,
  GetVendorsData,
  GetAllVendorsData,
  GetBillableVoyAges,
  GetUpdatedBillableVoyages,
  GetCompanyAddressdetails,
  GetAllProducts,
  GetCurrentQBbyCompany,
  GetWorkorderComments,
  CreateComment,

  GetAuthorizationDocument,
  GetAllVesselsByAccountId,
  GetVesselByofficialnumber,
  GetVesselByIMONumber,
  ResendEmails,
  UpdateBillingPrefix,
  CancelWorkorderInvoice,
  UpdateResendEmail,
  RegenerateAuthorizationLetter,
  RegenerateLLABDocument,
  GetVesselDetailsByIMONumber,
  GetERBPCListByIMONumber,
  GetProductsDataByIMONumber,
  GetSoftwareVersionPClist,
  GetListFiles,
  GetImoListFiles,
  GetFileUrl,
  GetAllActiveVaultsForUser,
  UpdateCustomerVault,
  DownloadFile,
  GetCompanyAddress,
  GetLastModifiedFiles,
  GetSearchLibrary,
  UpdateNdaDocument,
  GetVesselSyncData,
  GetPortByName,
  GetPortCities,
  GetInvestigatorByCityId,
  GetAllInvestigators,
  GetInspectorByName,
  GetInspectorDetailsByPortId,
  GetExpenseProducts,
  GetVesselByIMO,
  GetClassesList,
  GetAllVesselsByAgent,
  SendFeedBackEmail,
  GetAccountByAgentId,
  GetWorkorderProducts,
  GetDiscountProductCodeAmount,
  CancelAndReplaceWorkorderInvoice,
  LLABParentWorkOrders,
  LLABAmendmentWorkOrderData,
  PreviewLLABADocument,
  RegenerateLLABADocument
}
